module.exports = __webpack_public_path__ + "static/media/maestro_logo_light.a7fc037f.svg";